<div class="Rectangle-Copy">
    <div class="row error-page">
        <div class="col-lg-6 col-md-12 col-sm-12">
            <img src="../assets/images/maintenance-error.svg" class="Failure-Illustration">
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 error-message">
            <div class="headline">
                Maintenance!
            </div><br>
            <div class="subline">
                Dear User,
            </div><br>
            <div class="copy">
                We are implementing new features, functionalities and/or fixes to the System, this may take some
                time
                but there is nothing to worry about.
                <br><br>As soon as this planned maintenance is finished, the System's Operation will be back to
                normal.
                <br><br>Thank you.
            </div><br>
            <div class="copy-copy">
                Expected Time: {{expectedMaintenanceTime}}
            </div>
        </div>
    </div>
</div>